var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',{staticClass:"copyright"},[_vm._v("CopyRight 2023 版权所有 © 广州习创信息科技有限公司")])])
}]

export { render, staticRenderFns }